import React from 'react'

function Card({photo, msg}) {
  return (
    <div className='card text-black w-[33%] h-full flex flex-col justify-center items-center'><div className='h-[90%] flex justify-center items-center'><img src={photo} /></div>
    <div className='text-[1.7vmax] text-center font-bold h-fit'>{msg}</div></div>
  )
}

export default Card